import { REWARDS_WIDGET_NAMES } from "@/constants/widget-names";
import { RewardsCustomerPointsBalanceInlineWidgetDefinition } from "@apps/rewards/constants/definitions";
import type { RewardsWidgetInjectorConfig } from "@apps/rewards/types";
import WidgetInjectedSdkEvent from "@modules/sdk/common_sdk/events/WidgetInjectedSdkEvent";
import { dispatchSdkEvent } from "@modules/sdk/helpers";
import { parseBooleanDataAttr } from "@ui-utils/Injector/utils";

const GW_ENABLE_POINTS_NAME = "gw-enable-points-name";

class RewardsCustomerPointsBalanceInlineWidgetInjector {
    constructor(private readonly config: RewardsWidgetInjectorConfig) {}

    start(): void {
        this.config.logger.debug(
            "RewardsCustomerPointsBalanceWidgetInjector start",
            {
                placeholderSelector: this.config.placeholderSelector,
            }
        );

        const widgetName =
            REWARDS_WIDGET_NAMES.REWARDS_CUSTOMER_POINTS_BALANCE_INLINE_WIDGET;

        const targets$ = this.config.mutationObserverInjector.register({
            targetSelector: this.config.placeholderSelector,
        });

        targets$.subscribe((placeholder) => {
            this.config.logger?.debug(
                "RewardsCustomerPointsBalanceWidgetInjector found placeholder",
                {
                    placeholder,
                }
            );

            void (async () => {
                const RewardsCustomerPointsBalanceWidget =
                    await this.config.dynamicImportManager.importDefault(
                        RewardsCustomerPointsBalanceInlineWidgetDefinition,
                        true
                    );

                const widget = new RewardsCustomerPointsBalanceWidget(
                    {
                        target: placeholder,
                        isPointsNameEnabled: parseBooleanDataAttr(
                            placeholder,
                            GW_ENABLE_POINTS_NAME
                        ),
                    },
                    this.config.logger
                );

                widget.init();

                this.config.eventsCollector.pushEvent(
                    this.config.eventsFactory.createWidgetInjected(widgetName)
                );

                dispatchSdkEvent(new WidgetInjectedSdkEvent(widgetName));
            })();
        });
    }
}

export default RewardsCustomerPointsBalanceInlineWidgetInjector;
